import { Routes, Route, useLocation } from "react-router-dom";
import Top from "./Top";
import Bottom from "./Bottom";
import Home from "./components/Home";
import EmpLogin from "./components/EmpLogin";
import EmployeeAttendance from "./components/EmployeeAttendance";
import Cashbook from "./components/Cashbook";
import Dash from "./Dash";
import PrivateRoute from "./components/PrivateRoute";
import AdminDashboard from "./admin/AdminDashboard";
import EmployeesList from "./admin/EmployeesList";
import EmployeeForm from "./admin/EmployeeForm";
import EmployeeView from "./admin/EmployeeView";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      <Top />
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/EmpLogin" element={<EmpLogin />} />


        <Route
          path="/components/EmployeeAttendance"
          element={
            <PrivateRoute allowedRoles={["employee"]}>
              <EmployeeAttendance />
            </PrivateRoute>
          }
        />

        <Route
          path="/cashbook"
          element={
            <PrivateRoute>
              <Cashbook />
            </PrivateRoute>
          }
        />
        <Route
          path="/AdminDashboard"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/audit"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/dash"
          element={
            <PrivateRoute>
              <Dash />
            </PrivateRoute>
          }
        />
      </Routes>

      {isHomePage && <Bottom />}
    </>
  );
}

export default App;
